const BILLMA_ORIGINS = [
  'https://billma.plataforma-smart.com',
  'https://pre-billma.plataforma-smart.com',
  'https://pre2-billma.plataforma-smart.com',
  'https://pre2-billma.multiasistencia.garajedeideas.es',
  'https://billma.tadaima.studio'
]

function getReferrerOrigin () {
  try {
    return new URL(document.referrer).origin
  } catch {
    return ''
  }
}

// Detección inmediata por referrer (cubre peticiones iniciales durante la carga)
// + confirmación por postMessage (prueba criptográficamente segura de que el padre es BillMA)
let isInsideBillma = BILLMA_ORIGINS.includes(getReferrerOrigin())

window.addEventListener('message', (event) => {
  if (!BILLMA_ORIGINS.includes(event.origin)) return
  if (event.data?.source === 'billma') {
    isInsideBillma = true
  }
})

export const getIsInsideBillma = () => isInsideBillma
